var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.333333333333333,0,0,5.333333333333333,0,0)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M4.285 2.24H4.274C3.27412 2.46215 2.37995 3.01876 1.73921 3.81786C1.09847 4.61696 0.749519 5.61074 0.75 6.635V7.525C0.75 7.92282 0.908036 8.30436 1.18934 8.58566C1.47064 8.86696 1.85218 9.025 2.25 9.025H6C6.39783 9.025 6.77936 8.86696 7.06066 8.58566C7.34197 8.30436 7.5 7.92282 7.5 7.525V7.525C7.5 7.12718 7.65804 6.74564 7.93934 6.46434C8.22064 6.18304 8.60218 6.025 9 6.025H15C15.3978 6.025 15.7794 6.18304 16.0607 6.46434C16.342 6.74564 16.5 7.12718 16.5 7.525C16.5 7.92282 16.658 8.30436 16.9393 8.58566C17.2206 8.86696 17.6022 9.025 18 9.025H21.75C22.1478 9.025 22.5294 8.86696 22.8107 8.58566C23.092 8.30436 23.25 7.92282 23.25 7.525V6.635C23.25 5.61108 22.9009 4.61777 22.2602 3.81908C21.6195 3.02039 20.7255 2.46408 19.726 2.242H19.715C14.6191 1.25482 9.38116 1.25414 4.285 2.24V2.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M3.75 12.025V18.025C3.75 19.2185 4.22411 20.3631 5.06802 21.207C5.91193 22.0509 7.05653 22.525 8.25 22.525H15.75C16.9435 22.525 18.0881 22.0509 18.932 21.207C19.7759 20.3631 20.25 19.2185 20.25 18.025V12.025"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M7.875 14.275C7.66789 14.275 7.5 14.1071 7.5 13.9C7.5 13.6929 7.66789 13.525 7.875 13.525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M7.875 14.275C8.08211 14.275 8.25 14.1071 8.25 13.9C8.25 13.6929 8.08211 13.525 7.875 13.525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M7.875 18.025C7.66789 18.025 7.5 17.8571 7.5 17.65C7.5 17.4429 7.66789 17.275 7.875 17.275"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M7.875 18.025C8.08211 18.025 8.25 17.8571 8.25 17.65C8.25 17.4429 8.08211 17.275 7.875 17.275"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M12 14.275C11.7929 14.275 11.625 14.1071 11.625 13.9C11.625 13.6929 11.7929 13.525 12 13.525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M12 14.275C12.2071 14.275 12.375 14.1071 12.375 13.9C12.375 13.6929 12.2071 13.525 12 13.525"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M12 18.025C11.7929 18.025 11.625 17.8571 11.625 17.65C11.625 17.4429 11.7929 17.275 12 17.275"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M12 18.025C12.2071 18.025 12.375 17.8571 12.375 17.65C12.375 17.4429 12.2071 17.275 12 17.275"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M16.125 14.275C15.9179 14.275 15.75 14.1071 15.75 13.9C15.75 13.6929 15.9179 13.525 16.125 13.525"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M16.125 14.275C16.3321 14.275 16.5 14.1071 16.5 13.9C16.5 13.6929 16.3321 13.525 16.125 13.525"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M16.125 18.025C15.9179 18.025 15.75 17.8571 15.75 17.65C15.75 17.4429 15.9179 17.275 16.125 17.275"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000001",
    strokeWidth: 1.5,
    d: "M16.125 18.025C16.3321 18.025 16.5 17.8571 16.5 17.65C16.5 17.4429 16.3321 17.275 16.125 17.275"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandline);
export default __webpack_public_path__ + "static/media/landline.a50c63cb620aa543f30f52fb3d925efd.svg";
export { ForwardRef as ReactComponent };